import React from 'react'
import Spinner from '../spinner/spinner'
import "./pageloader.scss";

function pageloader() {
  return (
    <div className="page-loader"><Spinner /></div>
  )
}

export default pageloader